module.exports = __webpack_public_path__ + "img/icon-internship.799d346b.png";